export default "__VITE_ASSET__J23mmATq__"